import type { RouteObject } from "react-router"

export const loginRoutes: RouteObject[] = [
  {
    path: "/login",
    lazy: () => import("./login-page").then((m) => ({ Component: m.LoginPage })),
  },
]
